export function  injectScript() {
    return Promise.resolve();
}
